import { createApiClient } from '@mosaferati/api-client';
import { authEvents } from './auth-events.ts';

/** Single API client for the app; same-origin /api/v1 (Vite proxy in dev, Caddy in prod). */
export const api = createApiClient({
  baseUrl: '/api/v1',
  onUnauthenticated: () => authEvents.emit('unauthenticated'),
});
